var __jsx = React.createElement;
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import i18next from "i18next";
var MenuComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.PDMenuPage;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var MenuPage = function MenuPage() {
  var _store$common, _store$common2;
  var store = useStore();
  var conceptCode = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCode;
  var conceptCodeDesc = store === null || store === void 0 || (_store$common2 = store.common) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.appAttributes) === null || _store$common2 === void 0 || (_store$common2 = _store$common2.concept) === null || _store$common2 === void 0 ? void 0 : _store$common2.conceptCodeDesc;
  var router = useRouter();
  useEffect(function () {
    store === null || store === void 0 || store.initComponent("PrivateDining").then(function () {
      //
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("text.private_dining.page.menus.title", {
    defaultValue: "Sample Menus |  Private Dining | ".concat(conceptCodeDesc, " Restaurant")
  })), __jsx("meta", {
    name: "description",
    content: i18next.t("text.private_dining.page.menus.metadescription", {
      defaultValue: "Get a taste of what we can offer and download sample menus for private dining events at ".concat(conceptCodeDesc, ". See hors d' oeuvres, lunch, and dinner menus.")
    })
  }), __jsx("script", {
    src: "https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js",
    defer: true
  }), __jsx("script", {
    src: "https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js",
    defer: true
  }), __jsx("link", {
    rel: "stylesheet",
    href: "/pd/common/common.css"
  }), conceptCode ? __jsx("link", {
    rel: "stylesheet",
    href: "/pd/css/".concat(conceptCode === null || conceptCode === void 0 ? void 0 : conceptCode.toLocaleLowerCase(), "_PD.css")
  }) : null), __jsx(MenuComp, {
    route: router === null || router === void 0 ? void 0 : router.asPath
  }));
};
MenuPage.layout = PageLayout.NB_LAYOUT;
MenuPage.layoutProps = {
  analyticsData: {
    pageName: "private-dining sample-menus",
    pageType: "private-dining"
  }
};
export default observer(MenuPage);